import { useRoutes ,Router} from "react-router-dom";
import {  useSelector } from "react-redux";

// routes
import MainLayout from "./MainRoutes";
import AuthenticationRoutes from "./AuthenticationRoutes";
// import SimpleHeaderRoutes from "./SimpleHeader";

// ==============================|| ROUTING RENDER ||============================== //

export default function ThemeRoutes() {
  const loginStatus = useSelector((state) => state?.aiwritemate?.isLogging);

  return useRoutes(
    loginStatus? [MainLayout] : [AuthenticationRoutes]
  );
}
